import { render, staticRenderFns } from "./termsCreateModal.vue?vue&type=template&id=f469a472&"
import script from "./termsCreateModal.vue?vue&type=script&lang=ts&"
export * from "./termsCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports